
import { toString as toString_1, Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { array_type, anonRecord_type, string_type, record_type, class_type, option_type, list_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { DTO_AssignmentHookDto_$reflection, DTO_CreateProcedureDto_$reflection, DTO_CreateProcedureDto, ProcedureTrigger, DTO_SenderHookDto, DTO_GetStatusChangeHooksRequest_$reflection, DTO_GetStatusChangeHooksRequest, DTO_GetSenderHooksRequest_$reflection, DTO_GetSenderHooksRequest, DTO_StatusChangeHookDto_$reflection, DTO_SenderHookDto_$reflection, ProcedureEntityReferenceDto_$reflection } from "../../Shared/Procedure.js";
import { ProcedureTemplateSelection, FormState__setValidationResponse_5219762A, ProcedureId as ProcedureId_1, ProcedureTemplateId, FormState__startLoading, FormState_get_empty, RequestedValue$1, ClientApiResponse$1_$reflection, FormState_$reflection, ProcedureId_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { filter, isEmpty, singleton, append, map, exists, ofArray, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { add, contains, empty as empty_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { stringHash, createObj, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_2, append as append_1, singleton as singleton_1, collect, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import { TextButton } from "../../Components/Button.js";
import { OpenProcedureModal } from "./Form/View.js";
import { List_distinctBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { MultiSelect } from "../../Components/Select.js";

export class HookSource extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Sender", "Receiver"];
    }
}

export function HookSource_$reflection() {
    return union_type("Widgets.Procedure.Hooks.HookSource", [], HookSource, () => [[], []]);
}

export class HookFlowKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Assignment", "Return", "StatusChange"];
    }
}

export function HookFlowKind_$reflection() {
    return union_type("Widgets.Procedure.Hooks.HookFlowKind", [], HookFlowKind, () => [[], [], []]);
}

export class HookFlowState extends Record {
    constructor(EntityReference, FlowKind, SenderHooks, ReceiverHooks, ActiveProcedureId, ActiveProcedureTemplateId, ActiveHookSource, CompletedSenderHookTemplateIds, CompletedReceiverHookTemplateIds, CompletedProcedureIds, FormState) {
        super();
        this.EntityReference = EntityReference;
        this.FlowKind = FlowKind;
        this.SenderHooks = SenderHooks;
        this.ReceiverHooks = ReceiverHooks;
        this.ActiveProcedureId = ActiveProcedureId;
        this.ActiveProcedureTemplateId = ActiveProcedureTemplateId;
        this.ActiveHookSource = ActiveHookSource;
        this.CompletedSenderHookTemplateIds = CompletedSenderHookTemplateIds;
        this.CompletedReceiverHookTemplateIds = CompletedReceiverHookTemplateIds;
        this.CompletedProcedureIds = CompletedProcedureIds;
        this.FormState = FormState;
    }
}

export function HookFlowState_$reflection() {
    return record_type("Widgets.Procedure.Hooks.HookFlowState", [], HookFlowState, () => [["EntityReference", ProcedureEntityReferenceDto_$reflection()], ["FlowKind", HookFlowKind_$reflection()], ["SenderHooks", RequestedValue$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))], ["ReceiverHooks", RequestedValue$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))], ["ActiveProcedureId", option_type(ProcedureId_$reflection())], ["ActiveProcedureTemplateId", option_type(class_type("System.Guid"))], ["ActiveHookSource", option_type(HookSource_$reflection())], ["CompletedSenderHookTemplateIds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])], ["CompletedReceiverHookTemplateIds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])], ["CompletedProcedureIds", list_type(class_type("System.Guid"))], ["FormState", FormState_$reflection()]]);
}

export class HookFlowMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SenderHooksFetched", "ReceiverHooksFetched", "StatusChangeHooksFetched", "StartHookProcedure", "ContinueHookProcedure", "HookProcedureCreated", "HookProcedureCompleted", "CloseProcedureModal", "HookFetchError"];
    }
}

export function HookFlowMsg_$reflection() {
    return union_type("Widgets.Procedure.Hooks.HookFlowMsg", [], HookFlowMsg, () => [[["Item", ClientApiResponse$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))]], [["Item", ClientApiResponse$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))]], [["Item", ClientApiResponse$1_$reflection(list_type(DTO_StatusChangeHookDto_$reflection()))]], [["Item1", DTO_SenderHookDto_$reflection()], ["Item2", HookSource_$reflection()]], [["procedureId", class_type("System.Guid")], ["templateId", class_type("System.Guid")], ["Item3", HookSource_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [], [["Item", class_type("System.Exception")]]]);
}

export function HookFlow_empty(flowKind, entityReference) {
    return new HookFlowState(entityReference, flowKind, new RequestedValue$1(1, [empty()]), new RequestedValue$1(1, [empty()]), undefined, undefined, undefined, empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), empty_1({
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), empty(), FormState_get_empty());
}

export function HookFlow_buildRequest(entityReference, categoryIds) {
    return new DTO_GetSenderHooksRequest(categoryIds, (entityReference.tag === 1) ? "" : ((entityReference.tag === 2) ? "" : ((entityReference.tag === 3) ? "" : entityReference.fields[0])), entityReference);
}

export function HookFlow_initAssignment(entityReference, categoryIds) {
    let bind$0040, request;
    return [(bind$0040 = HookFlow_empty(new HookFlowKind(0, []), entityReference), new HookFlowState(bind$0040.EntityReference, bind$0040.FlowKind, new RequestedValue$1(0, []), bind$0040.ReceiverHooks, bind$0040.ActiveProcedureId, bind$0040.ActiveProcedureTemplateId, bind$0040.ActiveHookSource, bind$0040.CompletedSenderHookTemplateIds, bind$0040.CompletedReceiverHookTemplateIds, bind$0040.CompletedProcedureIds, bind$0040.FormState)), (request = HookFlow_buildRequest(entityReference, categoryIds), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_SenderHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/assignment-sender", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_GetSenderHooksRequest_$reflection(), undefined, undefined, undefined)(request))], (Item) => (new HookFlowMsg(0, [Item])), (Item_1) => (new HookFlowMsg(8, [Item_1]))))];
}

export function HookFlow_initReturn(entityReference, categoryIds) {
    let bind$0040, request, request_1;
    return [(bind$0040 = HookFlow_empty(new HookFlowKind(1, []), entityReference), new HookFlowState(bind$0040.EntityReference, bind$0040.FlowKind, new RequestedValue$1(0, []), new RequestedValue$1(0, []), bind$0040.ActiveProcedureId, bind$0040.ActiveProcedureTemplateId, bind$0040.ActiveHookSource, bind$0040.CompletedSenderHookTemplateIds, bind$0040.CompletedReceiverHookTemplateIds, bind$0040.CompletedProcedureIds, bind$0040.FormState)), Cmd_batch(ofArray([(request = HookFlow_buildRequest(entityReference, categoryIds), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_SenderHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/return-sender", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_GetSenderHooksRequest_$reflection(), undefined, undefined, undefined)(request))], (Item) => (new HookFlowMsg(0, [Item])), (Item_1) => (new HookFlowMsg(8, [Item_1])))), (request_1 = HookFlow_buildRequest(entityReference, categoryIds), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(DTO_SenderHookDto_$reflection())));
        }, refreshOn_1)))(true);
    })), ["/api/procedure-templates/hooks/return-receiver", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_GetSenderHooksRequest_$reflection(), undefined, undefined, undefined)(request_1))], (Item_2) => (new HookFlowMsg(1, [Item_2])), (Item_3) => (new HookFlowMsg(8, [Item_3]))))]))];
}

export function HookFlow_initReturnSender(entityReference, categoryIds) {
    let bind$0040, request;
    return [(bind$0040 = HookFlow_empty(new HookFlowKind(1, []), entityReference), new HookFlowState(bind$0040.EntityReference, bind$0040.FlowKind, new RequestedValue$1(0, []), bind$0040.ReceiverHooks, bind$0040.ActiveProcedureId, bind$0040.ActiveProcedureTemplateId, bind$0040.ActiveHookSource, bind$0040.CompletedSenderHookTemplateIds, bind$0040.CompletedReceiverHookTemplateIds, bind$0040.CompletedProcedureIds, bind$0040.FormState)), (request = HookFlow_buildRequest(entityReference, categoryIds), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_SenderHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/return-sender", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_GetSenderHooksRequest_$reflection(), undefined, undefined, undefined)(request))], (Item) => (new HookFlowMsg(0, [Item])), (Item_1) => (new HookFlowMsg(8, [Item_1]))))];
}

export function HookFlow_initStatusChange(entityReference, categoryIds, targetStateKey) {
    let bind$0040;
    const request = new DTO_GetStatusChangeHooksRequest(categoryIds, entityReference, targetStateKey);
    return [(bind$0040 = HookFlow_empty(new HookFlowKind(2, []), entityReference), new HookFlowState(bind$0040.EntityReference, bind$0040.FlowKind, new RequestedValue$1(0, []), bind$0040.ReceiverHooks, bind$0040.ActiveProcedureId, bind$0040.ActiveProcedureTemplateId, bind$0040.ActiveHookSource, bind$0040.CompletedSenderHookTemplateIds, bind$0040.CompletedReceiverHookTemplateIds, bind$0040.CompletedProcedureIds, bind$0040.FormState)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_StatusChangeHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/status-change", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_GetStatusChangeHooksRequest_$reflection(), undefined, undefined, undefined)(request))], (Item) => (new HookFlowMsg(2, [Item])), (Item_1) => (new HookFlowMsg(8, [Item_1])))];
}

function HookFlow_toSenderHook(hook) {
    return new DTO_SenderHookDto(hook.ProcedureTemplateId, hook.ProcedureTemplateName, hook.IsMandatory, hook.IsCompleted, hook.ProcedureId);
}

export function HookFlow_procedureTrigger(flowKind, source) {
    switch (flowKind.tag) {
        case 1:
            if (source.tag === 1) {
                return new ProcedureTrigger(4, []);
            }
            else {
                return new ProcedureTrigger(3, []);
            }
        case 2:
            return new ProcedureTrigger(5, []);
        default:
            if (source.tag === 1) {
                return new ProcedureTrigger(2, []);
            }
            else {
                return new ProcedureTrigger(1, []);
            }
    }
}

function HookFlow_hasMandatoryUncompleted(hooks, completedIds) {
    if (hooks.tag === 0) {
        return true;
    }
    else {
        return exists((hook) => {
            if (hook.IsMandatory) {
                return !contains(hook.ProcedureTemplateId, completedIds);
            }
            else {
                return false;
            }
        }, hooks.fields[0]);
    }
}

export function HookFlow_completedProcedureIds(state) {
    return state.CompletedProcedureIds;
}

export function HookFlow_hasMandatoryUncompletedHooks(state) {
    if (HookFlow_hasMandatoryUncompleted(state.SenderHooks, state.CompletedSenderHookTemplateIds)) {
        return true;
    }
    else {
        return HookFlow_hasMandatoryUncompleted(state.ReceiverHooks, state.CompletedReceiverHookTemplateIds);
    }
}

export function HookFlow_update(msg, state) {
    let body, matchValue_6, FormState_3;
    switch (msg.tag) {
        case 1: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new HookFlowState(state.EntityReference, state.FlowKind, state.SenderHooks, new RequestedValue$1(1, [empty()]), state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, state.FormState), Cmd_none()];
            }
            else {
                return [new HookFlowState(state.EntityReference, state.FlowKind, state.SenderHooks, new RequestedValue$1(1, [response_1.fields[0]]), state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, state.FormState), Cmd_none()];
            }
        }
        case 2: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new HookFlowState(state.EntityReference, state.FlowKind, new RequestedValue$1(1, [empty()]), state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, state.FormState), Cmd_none()];
            }
            else {
                return [new HookFlowState(state.EntityReference, state.FlowKind, new RequestedValue$1(1, [map(HookFlow_toSenderHook, response_2.fields[0])]), state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, state.FormState), Cmd_none()];
            }
        }
        case 3: {
            const source = msg.fields[1];
            const hook_1 = msg.fields[0];
            const dto = new DTO_CreateProcedureDto(undefined, state.EntityReference, HookFlow_procedureTrigger(state.FlowKind, source));
            return [new HookFlowState(state.EntityReference, state.FlowKind, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, hook_1.ProcedureTemplateId, source, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, FormState__startLoading(state.FormState)), (body = toString(0, Auto_generateBoxedEncoder_437914C6(DTO_CreateProcedureDto_$reflection(), undefined, undefined, undefined)(dto)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_3) => {
                    const pr = response_3.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), [concat("/api/procedure-templates/", toString_1(new ProcedureTemplateId(hook_1.ProcedureTemplateId)), ..."/procedure"), body], (Item) => (new HookFlowMsg(5, [Item])), (Item_1) => (new HookFlowMsg(8, [Item_1]))))];
        }
        case 4:
            return [new HookFlowState(state.EntityReference, state.FlowKind, state.SenderHooks, state.ReceiverHooks, new ProcedureId_1(msg.fields[0]), msg.fields[1], msg.fields[2], state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, state.FormState), Cmd_none()];
        case 5: {
            const response_5 = msg.fields[0];
            if (response_5.tag === 1) {
                return [new HookFlowState(state.EntityReference, state.FlowKind, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, undefined, undefined, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, FormState__setValidationResponse_5219762A(state.FormState, response_5.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                const procedureGuid = parse(response_5.fields[0]);
                const withProcedureId = (hooks_3) => {
                    const matchValue = state.ActiveProcedureTemplateId;
                    let matchResult, hooks_4, templateId_1;
                    if (hooks_3.tag === 1) {
                        if (matchValue != null) {
                            matchResult = 0;
                            hooks_4 = hooks_3.fields[0];
                            templateId_1 = matchValue;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0:
                            return new RequestedValue$1(1, [map((hook_2) => {
                                if (hook_2.ProcedureTemplateId === templateId_1) {
                                    return new DTO_SenderHookDto(hook_2.ProcedureTemplateId, hook_2.ProcedureTemplateName, hook_2.IsMandatory, hook_2.IsCompleted, procedureGuid);
                                }
                                else {
                                    return hook_2;
                                }
                            }, hooks_4)]);
                        default:
                            return hooks_3;
                    }
                };
                let patternInput;
                const matchValue_2 = state.ActiveHookSource;
                patternInput = ((matchValue_2 == null) ? [state.SenderHooks, state.ReceiverHooks] : ((matchValue_2.tag === 1) ? [state.SenderHooks, withProcedureId(state.ReceiverHooks)] : [withProcedureId(state.SenderHooks), state.ReceiverHooks]));
                return [new HookFlowState(state.EntityReference, state.FlowKind, patternInput[0], patternInput[1], new ProcedureId_1(procedureGuid), state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, FormState_get_empty()), Cmd_none()];
            }
        }
        case 6: {
            let patternInput_1;
            const matchValue_3 = state.ActiveHookSource;
            const matchValue_4 = state.ActiveProcedureTemplateId;
            let matchResult_1, templateId_2, templateId_3;
            if (matchValue_3 != null) {
                if (matchValue_3.tag === 1) {
                    if (matchValue_4 != null) {
                        matchResult_1 = 1;
                        templateId_3 = matchValue_4;
                    }
                    else {
                        matchResult_1 = 2;
                    }
                }
                else if (matchValue_4 != null) {
                    matchResult_1 = 0;
                    templateId_2 = matchValue_4;
                }
                else {
                    matchResult_1 = 2;
                }
            }
            else {
                matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0: {
                    patternInput_1 = [add(templateId_2, state.CompletedSenderHookTemplateIds), state.CompletedReceiverHookTemplateIds];
                    break;
                }
                case 1: {
                    patternInput_1 = [state.CompletedSenderHookTemplateIds, add(templateId_3, state.CompletedReceiverHookTemplateIds)];
                    break;
                }
                default:
                    patternInput_1 = [state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds];
            }
            return [new HookFlowState(state.EntityReference, state.FlowKind, state.SenderHooks, state.ReceiverHooks, undefined, undefined, undefined, patternInput_1[0], patternInput_1[1], (matchValue_6 = state.ActiveProcedureId, (matchValue_6 == null) ? state.CompletedProcedureIds : append(state.CompletedProcedureIds, singleton(matchValue_6.fields[0]))), state.FormState), Cmd_none()];
        }
        case 7:
            return [new HookFlowState(state.EntityReference, state.FlowKind, state.SenderHooks, state.ReceiverHooks, undefined, undefined, undefined, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, state.FormState), Cmd_none()];
        case 8: {
            const loadedOrEmpty = (hooks_5) => {
                if (hooks_5.tag === 1) {
                    return new RequestedValue$1(1, [hooks_5.fields[0]]);
                }
                else {
                    return new RequestedValue$1(1, [empty()]);
                }
            };
            return [(FormState_3 = FormState_get_empty(), new HookFlowState(state.EntityReference, state.FlowKind, loadedOrEmpty(state.SenderHooks), loadedOrEmpty(state.ReceiverHooks), state.ActiveProcedureId, undefined, undefined, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, FormState_3)), Cmd_errorToast("general.a_error_occured")];
        }
        default: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new HookFlowState(state.EntityReference, state.FlowKind, new RequestedValue$1(1, [empty()]), state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, state.FormState), Cmd_none()];
            }
            else {
                return [new HookFlowState(state.EntityReference, state.FlowKind, new RequestedValue$1(1, [response.fields[0]]), state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.CompletedProcedureIds, state.FormState), Cmd_none()];
            }
        }
    }
}

export function HooksSection(props) {
    let elems_3, elems_2;
    const patternInput = useTranslation();
    if (isEmpty(props.Hooks)) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_3 = [reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
            children: patternInput[0](props.TitleKey),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_2 = toList(delay(() => collect((hook) => {
            let elems_1;
            const isCompleted = contains(hook.ProcedureTemplateId, props.CompletedTemplateIds);
            return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "gap-2"])], (elems_1 = toList(delay(() => {
                let elems;
                return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append_1(singleton_1("h-5"), delay(() => append_1(singleton_1("w-5"), delay(() => (isCompleted ? singleton_1("text-green") : singleton_1("text-border")))))))))], (elems = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (isCompleted ? singleton_1(reactElement("span", {
                    className: join(" ", ["text-sm"]),
                    children: hook.ProcedureTemplateName,
                })) : singleton_1(createElement(TextButton, {
                    ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
                    Label: hook.ProcedureTemplateName,
                    OnClick: () => {
                        const matchValue = hook.ProcedureId;
                        if (matchValue == null) {
                            props.Dispatch(new HookFlowMsg(3, [hook, props.HookSource]));
                        }
                        else {
                            props.Dispatch(new HookFlowMsg(4, [matchValue, hook.ProcedureTemplateId, props.HookSource]));
                        }
                    },
                    TestId: `${props.TestIdPrefix}-procedure-${hook.ProcedureTemplateId}`,
                    Variant: "blueButton",
                })))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }, props.Hooks))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }
}

export function HookFlowSections(props) {
    let elems;
    const formState = props.State.FormState.IsLoading ? props.State.FormState : props.FormState;
    return reactElement("div", createObj(singleton((elems = toList(delay(() => {
        let matchValue;
        return append_1((matchValue = props.State.SenderHooks, (matchValue.tag === 0) ? (empty_2()) : singleton_1(createElement(HooksSection, {
            CompletedTemplateIds: props.State.CompletedSenderHookTemplateIds,
            Dispatch: props.Dispatch,
            FormState: formState,
            HookSource: new HookSource(0, []),
            Hooks: matchValue.fields[0],
            TestIdPrefix: concat(props.TestIdPrefix, ..."-sender"),
            TitleKey: props.SenderTitleKey,
        }))), delay(() => {
            const matchValue_1 = props.State.ReceiverHooks;
            if (matchValue_1.tag === 0) {
                return empty_2();
            }
            else {
                return singleton_1(createElement(HooksSection, {
                    CompletedTemplateIds: props.State.CompletedReceiverHookTemplateIds,
                    Dispatch: props.Dispatch,
                    FormState: formState,
                    HookSource: new HookSource(1, []),
                    Hooks: matchValue_1.fields[0],
                    TestIdPrefix: concat(props.TestIdPrefix, ..."-receiver"),
                    TitleKey: props.ReceiverTitleKey,
                }));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export function HookFlowProcedureModal(props) {
    const matchValue = props.State.ActiveProcedureId;
    if (matchValue == null) {
        return defaultOf();
    }
    else {
        return createElement(OpenProcedureModal, {
            IsOpen: true,
            OnCancelCallback: () => {
                props.Dispatch(new HookFlowMsg(7, []));
            },
            OnClose: () => {
                props.Dispatch(new HookFlowMsg(7, []));
            },
            OnSuccessCallback: () => {
                props.Dispatch(new HookFlowMsg(6, []));
            },
            ProcedureId: matchValue,
        });
    }
}

export class ReceiverProcedureState extends Record {
    constructor(AssignmentHooks, Selected) {
        super();
        this.AssignmentHooks = AssignmentHooks;
        this.Selected = Selected;
    }
}

export function ReceiverProcedureState_$reflection() {
    return record_type("Widgets.Procedure.Hooks.ReceiverProcedureState", [], ReceiverProcedureState, () => [["AssignmentHooks", RequestedValue$1_$reflection(list_type(DTO_AssignmentHookDto_$reflection()))], ["Selected", list_type(anonRecord_type(["label", string_type], ["value", DTO_AssignmentHookDto_$reflection()]))]]);
}

export class ReceiverProcedureMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AssignmentHooksFetched", "SetSelectedProcedureTemplates", "ReceiverProcedureFetchError"];
    }
}

export function ReceiverProcedureMsg_$reflection() {
    return union_type("Widgets.Procedure.Hooks.ReceiverProcedureMsg", [], ReceiverProcedureMsg, () => [[["Item", ClientApiResponse$1_$reflection(list_type(DTO_AssignmentHookDto_$reflection()))]], [["Item", option_type(array_type(anonRecord_type(["label", string_type], ["value", DTO_AssignmentHookDto_$reflection()])))]], [["Item", class_type("System.Exception")]]]);
}

function ReceiverProcedures_mandatoryOptions(hooks) {
    return map((hook) => ({
        label: hook.ProcedureTemplateName,
        value: hook,
    }), filter((_arg) => _arg.IsMandatory, hooks));
}

export function ReceiverProcedures_init(labelIds) {
    return [new ReceiverProcedureState(new RequestedValue$1(0, []), empty()), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_AssignmentHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/assignment", toString(0, Auto_generateBoxedEncoder_437914C6(list_type(class_type("System.Guid")), undefined, undefined, undefined)(labelIds))], (Item) => (new ReceiverProcedureMsg(0, [Item])), (Item_1) => (new ReceiverProcedureMsg(2, [Item_1])))];
}

export function ReceiverProcedures_update(msg, state) {
    let matchValue;
    switch (msg.tag) {
        case 1:
            return new ReceiverProcedureState(state.AssignmentHooks, List_distinctBy((option_2) => option_2.value.ProcedureTemplateId, append((matchValue = state.AssignmentHooks, (matchValue.tag === 0) ? empty() : ReceiverProcedures_mandatoryOptions(matchValue.fields[0])), defaultArg(map_1(ofArray, msg.fields[0]), empty())), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }));
        case 2:
            return new ReceiverProcedureState(new RequestedValue$1(1, [empty()]), state.Selected);
        default: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return new ReceiverProcedureState(new RequestedValue$1(1, [empty()]), state.Selected);
            }
            else {
                const hooks = response.fields[0];
                return new ReceiverProcedureState(new RequestedValue$1(1, [hooks]), ReceiverProcedures_mandatoryOptions(hooks));
            }
        }
    }
}

export function ReceiverProcedures_selections(state) {
    return map((option) => (new ProcedureTemplateSelection(option.value.ProcedureTemplateId, option.value.ProcedureTemplateName)), state.Selected);
}

export function ReceiverProcedureSelect(props) {
    const t = useTranslation()[0];
    const matchValue = props.State.AssignmentHooks;
    let matchResult, hooks_1;
    if (matchValue.tag === 1) {
        if (props.IsVisible && !isEmpty(matchValue.fields[0])) {
            matchResult = 0;
            hooks_1 = matchValue.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const mandatoryText = t("procedure.hooks.mandatory");
            const options = map((hook) => ({
                label: hook.IsMandatory ? concat(hook.ProcedureTemplateName, " (", mandatoryText, ...")") : hook.ProcedureTemplateName,
                value: hook,
            }), hooks_1);
            return createElement(MultiSelect, {
                ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
                IsClearable: false,
                Label: t("tool.dialog_assign_procedures"),
                NoOptionsMessage: "tool.dialog_assign_procedures_no_options",
                OnChange: (arg) => {
                    props.Dispatch(new ReceiverProcedureMsg(1, [arg]));
                },
                Options: options,
                PlaceholderKey: "tool.dialog_assign_procedures_placeholder",
                TestId: props.TestId,
                Value: props.State.Selected,
            });
        }
        default:
            return defaultOf();
    }
}

